import request from '@/utils/request'

/**
 * @name Room 列表
 */

export const getHotelRoomsSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/hotel_rooms/setup'
  })
}

export const getHotelRoomsList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/hotel_rooms',
    params
  })
}

export const deleteHotelRoomsDetails = (id) => {
  return request({
    method: 'DELETE',
    url: `/cms/hotel_rooms/${id}`
  })
}

export const postHotelRoomsAdd = (data) => {
  return request({
    method: 'POST',
    url: '/cms/hotel_rooms',
    data
  })
}

export const getHotelRoomsCollections = () => {
  return request({
    method: 'GET',
    url: '/cms/hotel_rooms/collections'
  })
}

export const updateHotelRoomsOnline = (id) => {
  return request({
    method: 'POST',
    url: `cms/hotel_rooms/${id}/online`
  })
}

export const updateHotelRoomsOffline = (id) => {
  return request({
    method: 'POST',
    url: `cms/hotel_rooms/${id}/offline`
  })
}

export const getHotelRoomsEditDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/hotel_rooms/${id}/preview`
  })
}

export const putHotelRoomsFormData = (data, id) => {
  return request({
    method: 'PUT',
    url: `cms/hotel_rooms/${id}`,
    data
  })
}

export const getHotelRoomsDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/hotel_rooms/${id}`
  })
}

/**
 * @name Policy 列表
 */

export const getHotelRoomPolicysSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/hotel_room_policies/setup'
  })
}

export const getHotelRoomPolicysList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/hotel_room_policies',
    params
  })
}

export const deleteHotelRoomPolicysDetails = (id) => {
  return request({
    method: 'DELETE',
    url: `/cms/hotel_room_policies/${id}`
  })
}

export const postHotelRoomPolicysAdd = (data) => {
  return request({
    method: 'POST',
    url: '/cms/hotel_room_policies',
    data
  })
}

export const getHotelRoomPolicysCollections = () => {
  return request({
    method: 'GET',
    url: '/cms/hotel_room_policies/collections'
  })
}

export const updateHotelRoomPolicysOnline = (id) => {
  return request({
    method: 'POST',
    url: `cms/hotel_room_policies/${id}/online`
  })
}

export const updateHotelRoomPolicysOffline = (id) => {
  return request({
    method: 'POST',
    url: `cms/hotel_room_policies/${id}/offline`
  })
}

export const getHotelRoomPolicysEditDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/hotel_room_policies/${id}/preview`
  })
}

export const putHotelRoomPolicysFormData = (data, id) => {
  return request({
    method: 'PUT',
    url: `cms/hotel_room_policies/${id}`,
    data
  })
}

export const getHotelRoomPolicysDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/hotel_room_policies/${id}`
  })
}

/**
 * @name Policy Price 列表
 */

export const getRoomPolicyPricesSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/room_policy_prices/setup'
  })
}

export const getRoomPolicyPricesList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/room_policy_prices',
    params
  })
}

export const deleteRoomPolicyPricesDetails = (id) => {
  return request({
    method: 'DELETE',
    url: `/cms/room_policy_prices/${id}`
  })
}

export const postRoomPolicyPricesAdd = (data) => {
  return request({
    method: 'POST',
    url: '/cms/room_policy_prices',
    data
  })
}

export const getRoomPolicyPricesCollections = () => {
  return request({
    method: 'GET',
    url: '/cms/room_policy_prices/collections'
  })
}

export const updateRoomPolicyPricesOnline = (id) => {
  return request({
    method: 'POST',
    url: `cms/room_policy_prices/${id}/online`
  })
}

export const updateRoomPolicyPricesOffline = (id) => {
  return request({
    method: 'POST',
    url: `cms/room_policy_prices/${id}/offline`
  })
}

export const getRoomPolicyPricesEditDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/room_policy_prices/${id}/preview`
  })
}

export const putRoomPolicyPricesFormData = (data, id) => {
  return request({
    method: 'PUT',
    url: `cms/room_policy_prices/${id}`,
    data
  })
}

export const getRoomPolicyPricesDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/room_policy_prices/${id}`
  })
}
